module.exports = __webpack_public_path__ + "img/longhouse_tech_Normal_ua.310c98cf.webp";